import { useCallback, useMemo } from "react";

import classNames from "classnames";

import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";

import {
  setIframeShow,
  setIframeLoading,
} from "../../../redux/reducers/uiReducer";

import Divider from "../../divider";
import Loading from "../../loading";

import { logDebug } from "../../../utils/logger";
import { isEmpty } from "../../../utils/validators";

function LandingIframe() {
  const { t } = useTranslation();

  const dispatch = useDispatch();
  const { ui } = useSelector((state) => state);
  const { is_iframe_loading, downloadBackground } = ui;

  const goToLandingAboutHandler = useCallback((evt) => {
    logDebug("LandingIframe", "goToLandingAboutHandler", { evt: evt });
    const el = document.getElementById("about");
    if (!isEmpty(el)) {
      el.scrollIntoView({
        block: "start",
        inline: "start",
        behavior: "smooth",
      });
    }
  }, []);

  const srcUrl = useMemo(() => {
    return process.env.REACT_APP_ADS;
  }, []);

  return (
    <div className="landing-iframe__container">
      {is_iframe_loading && <Loading />}
      <div className={classNames("announce", { hidden: is_iframe_loading })}>
        {!isEmpty(downloadBackground) ? (
          <div className="landing-iframe__background">
            <img
              src={downloadBackground}
              className="landing-iframe__background__image"
              alt="background"
              title="background"
              onLoad={() => {
                dispatch(setIframeLoading(false));
                dispatch(setIframeShow(true));
              }}
            />
          </div>
        ) : (
          <iframe
            className="landing-iframe__content"
            src={srcUrl}
            title="iframe"
            loading="lazy"
            onLoad={() => {
              dispatch(setIframeLoading(false));
              dispatch(setIframeShow(true));
            }}
          ></iframe>
        )}
        <Divider />
        <div
          className="landing-iframe__link"
          onClick={(evt) => goToLandingAboutHandler(evt)}
        >
          <span className="small-title">{t("footer_menu.about_us")}</span>
          <span className="icon-nav-arrow-down"></span>
        </div>
      </div>
    </div>
  );
}

export default LandingIframe;
